<template>
    <div>
        <span>{{ status }}</span>
        <br />
        <input
            type="file"
            name="files"
            id="csv-file"
            @change="handleFileSelect"
        />
    </div>
</template>

<script>
import "screw-filereader";
import XLSX from "xlsx";
import Papa from "papaparse";
export default {
    name: "GPSReader",
    data() {
        return {
            status: ""
        };
    },
    methods: {
        async handleFileSelect(e) {
            let file = e.target.files[0];
            if (file == undefined) {
                this.$emit("route-updated", {
                    route: [[[0, 0]]],
                    max: 0,
                    start: "",
                    end: ""
                });
            }
            if (file.name.split(".").slice(-1)[0] == "xlsx") {
                this.status = "converting xlsx to csv";
                file = await this.convertXLSX(file);
            }
            this.status = "parsing csv data";
            let results = await this.parseCSV(file);
            this.status = "";
            let coordinates = results.data.map(({ Longitude, Latitude }) => {
                return [Longitude, Latitude];
            });
            let route = this.splitCoords(coordinates);
            let max = results.data.reduce((prev, curr) => {
                if (curr["Veloctiy (km/h)"] > prev)
                    return curr["Veloctiy (km/h)"];
                return prev;
            }, 0);
            let start =
                results.data[0]["Time of reading (South Africa Standard Time)"];
            let end = results.data.slice(-1)[0][
                "Time of reading (South Africa Standard Time)"
            ];
            this.$emit("route-updated", { route, max, start, end });
        },
        async convertXLSX(file) {
            let arrayBuffer = await file.arrayBuffer();
            let data = new Uint8Array(arrayBuffer);
            let workbook = XLSX.read(data, { type: "array" });
            return XLSX.utils.sheet_to_csv(workbook.Sheets["Data"]);
        },
        parseCSV(file) {
            return new Promise(resolve => {
                Papa.parse(file, {
                    skipEmptyLines: true,
                    header: true,
                    dynamicTyping: true,
                    complete: results => {
                        resolve(results);
                    }
                });
            });
        },
        splitCoords(coordinates) {
            let routes = [];
            let i = 1;
            while (i < coordinates.length) {
                let [lon, lat] = coordinates[i];
                let [prevLon, prevLat] = coordinates[i - 1];
                let dist = Math.sqrt(
                    Math.pow(Math.abs(lon - prevLon), 2) +
                        Math.pow(Math.abs(lat - prevLat) > 0.05, 2)
                );
                if (dist > 0.05) {
                    let subroute = coordinates.splice(0, i);

                    routes.push(subroute);
                    i = 0;
                }
                i++;
            }
            routes.push(coordinates);
            return routes;
        }
    }
};
</script>

<style></style>
